//
// MapPin.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";
import "@sas-dvr/ltjs-commons/maps/GeoEnrichmentResult";

var MapPin = createModule("gtl::MapPin", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    {
        REVERSE_GEOCODE_COMPLETE: 30075,
        ROUTING_COMPLETE: 30074,
        GEO_ENRICHMENT_COMPLETE: 30073,
        BUFFER_COMPLETE: 30072,
    },
    ,
    ,
    {
        country: 7,
        address: 7,
        name: 7,
    },
    {
        getGeoEnrichmentData: [7],
        getGeoEnrichmentResults: [[1]],
        enrichBuffer: [0,[7]],
    },
    ,
    ,
]);
export default MapPin;
